<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2020-03-17 14:16:35
 * @LastEditors: mrh
 * @LastEditTime: 2020-08-20 17:38:30
 -->
<template>
  <!-- 视频播放弹窗页 -->
  <van-dialog
    v-model="showVideos"
    :showConfirmButton="false"
    :closeOnClickOverlay="true"
    @closed="close"
    overlayClass='overlays'
  >
    <video :src="vsrc" controls="controls" width="100%" height="100%" autoplay ref="video"></video>
  </van-dialog>
</template>

<script>
export default {
  name: "playVideos",
  props: {
    showVideo: {
      default: false,
      type: Boolean
    },
    videosrc: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      showVideos: this.showVideo
    };
  },
  watch: {
    //深度监听,自动播放和赋值
    showVideo: {
      handler(newV, oldV) {
        // 滚动条置顶
        // console.log(this.active)
        if (newV) {
          this.$nextTick(() => {
            this.$refs.video.play();
          });
        }
        this.showVideos = newV;
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("showVideo", false);
      this.$refs.video.pause();
    }
  },
  computed:{
    vsrc(){
      return this.videosrc
    }
  }
};
</script>

<style lang="scss" scoped>

</style>